export function extractApiError(error, fallback = 'Не удалось выполнить действие') {
  const data = error?.response?.data
  if (typeof data?.error === 'string') return data.error
  if (Array.isArray(data?.errors) && data.errors.length) return data.errors.join(', ')
  return fallback
}
